import script from "./UsageBasedFeaturesModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UsageBasedFeaturesModal.vue?vue&type=script&lang=ts&setup=true"

import "./UsageBasedFeaturesModal.vue?vue&type=style&index=0&id=9c6c83dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c6c83dc"]])

export default __exports__